import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { RefStatut } from './statut.ref.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

export class StatutHabilitation {
    static jsonMap = {
        id: { key: 'id', optional: true },
        idHabilitation: { key: 'idHabilitation', optional: true },
        statut: { key: 'idStatut', converter: new (DataIdConverterFactory.build(RefStatut, 'statutsHabilitation'))(), optional: true },
        dateReception: { key: 'dateReception', converter: new DateConverter(), optional: true },
        dateDebut: { key: 'dateDebut', converter: new DateConverter() },
        commentaire: { key: 'commentaire', optional: true, default: '' }
    };

    public id: number = undefined;
    public idHabilitation: number = undefined;
    public statut: RefStatut = undefined;
    public dateReception: moment.Moment = undefined;
    public dateDebut: moment.Moment = undefined;
    public commentaire: string = undefined;
}
